const popup = document.getElementById("popup");
const popupTitle = document.getElementById("popup-title");
const closeBtn = document.getElementById("popup-close");

const hintRow1 = document.querySelector(".hint-row-1");
const hintRow2 = document.querySelector(".hint-row-2 thead tr");
const tbody = document.querySelector(".hint-row-2 tbody");




const chartData = {
  "bra_size_chart": {
    "popup_title": document.getElementById("bra_size_tooltip_label").value,
    "description_1": document.getElementById("bra_size_tooltip_description").value,
    "hintRow1": [
      {
        "sub_header_title": document.getElementById("bra_size_tooltip_sublabel").value,
        "description_2": document.getElementById("bra_size_tooltip_subdescription").value,
        "description_3": ""
      }
    ],
    "hintRow2": {
      "table": {
        "title": "Cup Size Guide",
        "headers": [
          document.getElementById("bra_size_tooltip_table_header_1").value,
          document.getElementById("bra_size_tooltip_table_header_2").value,
        ],
        "rows": [
          { "size": "AA", "cm": "about 7.5" },
          { "size": "A", "cm": "about 10" },
          { "size": "B", "cm": "about 12.5" },
          { "size": "C", "cm": "about 15" },
          { "size": "D", "cm": "about 17.5" },
          { "size": "E", "cm": "about 20" },
          { "size": "F", "cm": "about 22.5" },
          { "size": "G", "cm": "about 25" },
          { "size": "H", "cm": "about 27.5" },
          { "size": "I", "cm": "about 30" }
        ]
      }
    }
  },
  "girdle_size_chart": {
    "popup_title": document.getElementById("girdle_size_tooltip_label").value,
    "description_1": document.getElementById("girdle_size_tooltip_description").value,
    "hintRow1": [
      {
        "sub_header_title": document.getElementById("girdle_size_tooltip_sublabel").value,
        "description_2": document.getElementById("girdle_size_tooltip_subdescription").value,
        "description_3": ""
      }
    ],
    "hintRow2": {
      "table": {
        "title": "Panty Size Guide",
        "headers": [
          document.getElementById("girdle_size_tooltip_table_header_1").value,
          document.getElementById("girdle_size_tooltip_table_header_2").value,
        ],
        "rows": [
          { "size": "M", "cm": "87-95" },
          { "size": "L", "cm": "92-100" },
          { "size": "LL", "cm": "97-105" },
          { "size": "3L/EL", "cm": "102-110" }
        ]
      }
    }
  },
  "panty_size_chart": {
    "popup_title": document.getElementById("panty_size_tooltip_label").value,
    "description_1": document.getElementById("panty_size_tooltip_description").value,
    "hintRow1": [
      {
        "sub_header_title": document.getElementById("panty_size_tooltip_sublabel").value,
        "description_2": document.getElementById("panty_size_tooltip_subdescription").value,
        "description_3": ""
      }
    ],
    "hintRow2": {
      "table": {
        "title": "Panty Size Guide",
        "headers": [
          document.getElementById("panty_size_tooltip_table_header_1").value,
          document.getElementById("panty_size_tooltip_table_header_2").value,
        ],
        "rows": [
          { "size": "M", "cm": "87-95" },
          { "size": "L", "cm": "92-100" },
          { "size": "LL", "cm": "97-105" },
          { "size": "3L/EL", "cm": "102-110" }
        ]
      }
    }
  }
};

// Render hint row 1 (includes description_1 + sub-sections)
function renderHintRow1(hints = [], description1 = "") {
  hintRow1.innerHTML = "";

  // Add description_1 if it exists
  if (description1) {
    const desc = document.createElement("p");
    desc.textContent = description1;
    hintRow1.appendChild(desc);
  }

  // Add sub_header_title, description_2, description_3
  hints.forEach(({ sub_header_title, description_2, description_3 }) => {
    const div = document.createElement("div");
    div.innerHTML = `
      <p><strong>${sub_header_title}</strong></p>
      <p>${description_2}${description_3 ? `<br>${description_3}` : ""}</p>
    `;
    hintRow1.appendChild(div);
  });
}

// Render table (headers + rows)
function renderTable(headers = [], rows = []) {
  hintRow2.innerHTML = "";
  tbody.innerHTML = "";

  headers.forEach(header => {
    const th = document.createElement("th");
    th.className = "sized-th";
    th.textContent = header;
    hintRow2.appendChild(th);
  });

  rows.forEach(row => {
    const tr = document.createElement("tr");
    Object.values(row).forEach(value => {
      const td = document.createElement("td");
      td.className = "sized-td";
      td.textContent = value;
      tr.appendChild(td);
    });
    tbody.appendChild(tr);
  });
}

// Map data-hint to chart key
function getChartKey(hintType) {
  if (hintType === "bra-size-hint") return "bra_size_chart";
  if (hintType === "girdle-size-hint") return "girdle_size_chart";
  if (hintType === "panty-size-hint") return "panty_size_chart";
  return null;
}

// Click handler for all .calculator-header items
document.querySelectorAll(".calculator-header").forEach(header => {
  header.addEventListener("click", () => {
    const hintType = header.dataset.hint;
    const key = getChartKey(hintType);
    const chart = chartData[key];

    if (!chart) return;

    popupTitle.textContent = chart.popup_title;

    // Render description and hint row 1
    if (chart.hintRow1) {
      hintRow1.style.display = "block";
      renderHintRow1(chart.hintRow1, chart.description_1);
    } else {
      hintRow1.style.display = "none";
      hintRow1.innerHTML = "";
    }

    // Render table
    const table = chart.hintRow2?.table;
    if (table) {
      renderTable(table.headers, table.rows);
    }

    // Show popup
    popup.style.display = "flex";
  });
});

// Close popup events
closeBtn.addEventListener("click", () => popup.style.display = "none");

popup.addEventListener("click", e => {
  if (e.target === popup) popup.style.display = "none";
});
